import React, { useState, Fragment, useEffect } from "react";
import { connect } from "react-redux";
import * as pdfjsLib from "pdfjs-dist/webpack";
import { bindActionCreators } from "redux";
import CustomLoader from "../../common/CustomLoader";
// import crossCheckIcon from '../../../assets/check-icons/cross-check.png';
// import dotCheckIcon from '../../../assets/check-icons/dot-check.png';
// import tickCheckIcon from '../../../assets/check-icons/tick-check.png';
import CrossUnCheck from "../../../assets/check-icons/cross-uncheck.png";
import DotUnCheck from "../../../assets/check-icons/dot-uncheck.png";
import TickUnCheck from "../../../assets/check-icons/tick-uncheck.png";
import {
  getAlertToast,
} from "../../../utils/functions/CustomFunctions";
import Swal from "sweetalert2";

const checkboxImagesType = {
  Cross: CrossUnCheck,
  Tick: TickUnCheck,
  Dot: DotUnCheck,
};
const checkboxImagesSize = {
  Small: 10,
  Medium: 20,
  Large: 30,
};

function CanvasComponent(props) {
  const { record = {}, documentIndex } = props;
  const { elements = [], documentURL = "" } = record;
  //State
  const [loading, setLoading] = useState(false);
  const [pdfDimension, setPdfDimension] = useState({
    width: 700,
    height: 900,
  });

  const generatePdf = () => {
    if (documentURL) {
      let loadingTask = pdfjsLib.getDocument({ url: documentURL });
      loadingTask.onProgress = function (progress) {
        // Swal.fire(getAlertToast("success", "Please wait...", 2000));
      };
      loadingTask.promise
        .then(function (doc) {
          // load pdf
          return doc.getPage(1).then((page) => {
            let canvasId = `canvas_preview_${documentIndex}`;
            var canvas = document.getElementById(canvasId);
            var context = canvas?.getContext("2d");
            var viewport = page.getViewport({ scale: 1 });
            canvas.width = viewport.width;
            canvas.height = viewport.height;
            setPdfDimension({
              width: viewport.width,
              height: viewport.height,
            });
            return page.render({
              canvasContext: context,
              viewport: viewport,
            }).promise;
          });
        })
        .catch((error) => {
          console.error("PDF loading failed", error);
          setLoading(false);
          Swal.fire(getAlertToast("error", "File loading failed", 2000));
        });
    }
  };

  useEffect(() => {
    generatePdf();
  }, [documentURL]);

  return (
    <Fragment>
      <center>{loading && <CustomLoader loading={loading} />}</center>

      <div
        id="viewPdf"
        style={{
          position: "relative",
          alignSelf: "center",
          width: pdfDimension.width,
          height: pdfDimension.height,
        }}
      >
        <canvas
          data-document_id={documentIndex}
          id={`canvas_preview_${documentIndex}`}
          style={{
            border: "2px solid #1b3e6f",
            display: "inline-block",
            cursor: "auto",
          }}
        ></canvas>
        {elements.map((element, i) => {
          const {
            propertyType,
            elementId,
            yCord,
            xCord,
            fontSize,
            width,
            height,
            isBold,
            justify,
            placeholder = "",
            isItalic,
            checkboxType = "",
            checkboxSize = "",
            variableId = "",
            variableLabel = "",
            variableTypeId = 0,
            variableFee = 0,
            hidePlaceholder = false,
            maskedvalue,
            characterLimit,
          } = element;
          const mValue =
            characterLimit && maskedvalue?.toString()?.length > characterLimit
              ? maskedvalue?.toString()?.substring(0, characterLimit)
              : maskedvalue;
          return (
            <div
              className="draggableDiv"
              key={`divList_${i}`}
              id={`doc_${documentIndex}_element_${elementId}`}
              style={{
                position: "absolute",
                zindex: "9",
                top: yCord + "px",
                left: xCord + "px",
              }}
            >
              {propertyType == "Text" ||
              propertyType == "Number" ||
              propertyType == "Date" ||
              propertyType == "MaskedTextBox" ||
              (propertyType == "Variable" && variableTypeId != 1) ? (
                <div
                  style={{
                    zindex: "10",
                    fontSize: fontSize + "px",
                    border: "2px solid #1b3e6f",
                    pointerEvents: "all",
                    width: width ? `${width}px` : "100px",
                    height: height ? `${height}px` : "27px",
                    fontWeight: isBold ? "bold" : "normal",
                    fontStyle: isItalic ? "italic" : "normal",
                    textAlign: justify ? justify : "left",
                    cursor: "auto",
                    resize: "none",
                    padding: "3px",
                    overflow: "none",
                  }}
                >
                  {propertyType === "Text" ||
                  propertyType === "Number" ||
                  propertyType == "MaskedTextBox" ||
                  propertyType === "Date"
                    ? hidePlaceholder
                      ? ""
                      : maskedvalue
                      ? mValue
                      : placeholder
                    : hidePlaceholder
                    ? ""
                    : variableTypeId == 3
                    ? variableLabel
                    : variableTypeId == 4
                    ? variableLabel
                    : `$${parseFloat(variableFee).toFixed(
                        2
                      )} - ${variableLabel}`}
                </div>
              ) : propertyType == "Image" || propertyType == "Signature" ? (
                <div
                  key={`img_place_${width}_${height}`}
                  style={{
                    fontSize: fontSize + "px",
                    border: "2px solid #1b3e6f",
                    pointerEvents: "all",
                    width: width + "px",
                    height: height + "px",
                    cursor: "auto",
                    resize: "none",
                    padding: "5px",
                    overflow: "auto",
                  }}
                >
                  <div>{hidePlaceholder ? "" : placeholder}</div>
                </div>
              ) : propertyType == "Variable" && variableTypeId == 1 ? (
                <div
                  style={{
                    zindex: "10",
                    fontSize: fontSize + "px",
                    // border: '2px solid #1b3e6f',
                    pointerEvents: "all",
                    width: width ? `${width}px` : "100px",
                    height: height ? `${height}px` : "27px",
                    fontWeight: isBold ? "bold" : "normal",
                    fontStyle: isItalic ? "italic" : "normal",
                    textAlign: justify ? justify : "left",
                    cursor: "auto",
                    resize: "none",
                    // padding: '3px',
                    overflow: "none",
                    // TESTING-PRODUCTION
                    padding: "2px",
                    border: "2px dashed transparent",
                  }}
                >
                  <div>
                    <img
                      src={checkboxImagesType[checkboxType]}
                      style={{
                        width: `${checkboxImagesSize[checkboxSize]}px`,
                        height: `${checkboxImagesSize[checkboxSize]}px`,
                        marginRight: `${propertyType == "Variable" ? 3 : 0}px`,
                        border: "1px solid #1b3e6f",
                      }}
                      alt="no data"
                    />
                    {propertyType == "Variable" && hidePlaceholder == false
                      ? `$${parseFloat(variableFee).toFixed(
                          2
                        )} - ${variableLabel}`
                      : ""}
                  </div>
                </div>
              ) : (
                <div
                  key={`img_place_${width}_${height}`}
                  style={{
                    fontSize: fontSize + "px",
                    // border: '2px solid #1b3e6f',
                    pointerEvents: "all",
                    cursor: "auto",
                    resize: "none",
                    // padding: '2px',
                    overflow: "auto",
                    // TESTING-PRODUCTION
                    padding: "2px",
                    border: "2px dashed transparent",
                  }}
                >
                  <div>
                    <img
                      src={checkboxImagesType[checkboxType]}
                      style={{
                        width: `${checkboxImagesSize[checkboxSize]}px`,
                        height: `${checkboxImagesSize[checkboxSize]}px`,
                        border: "1px solid #1b3e6f",
                      }}
                      alt="no data"
                    />
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </Fragment>
  );
}
const getState = ({ CreateDocumentForm }) => {
  return {
    CreateDocumentForm,
  };
};
const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      //
    },
    dispatch
  ),
  dispatch,
});
export default connect(getState, mapDispatchToProps)(CanvasComponent);
